import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { MatomoTracker } from 'ngx-matomo';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { differenceInCalendarDays } from 'date-fns';
import { Observable } from 'rxjs/internal/Observable';
import { TranslateService } from '@ngx-translate/core';
import { LayoutComponent } from 'src/app/layout/layout.component';


interface ItemData {
  id: number;
  name: string;
  age: number;
  address: string;
}

@Component({
  selector: 'app-WmsmContractSendingComponent',
  templateUrl: './wmsm-ContractSending.component.html',
  styleUrls: ['./wmsm-ContractSending.component.scss'],
})

export class WmsmContractSendingComponent extends BaseComponent implements OnInit {
  ConcatTitle: string
  VendorConcatTile: string
  pageSize: number = 20;
  // 表格页码
  public uploadedFileName: string;
  PaddingData: any[] = [];
  select: boolean = false
  SiteList: any;
  pageIndex: number = 1;
  fileList: NzUploadFile[] = [];
  total: number = 0;
  validateForm: FormGroup;
  formValues: any;
  chartOption: any;
  seriesData: any[];
  SiteAll: any;
  option: any;
  startValue: any = 10;
  endValue: any = 100;
  dataZoomOrient: any = 'horizontal';
  barChartOrient: any = 'vertical';
  loading: boolean = false;
  isShowCondition: boolean = true;
  today = new Date();
  isShowinfo: boolean = false;
  monthFormat = 'yyyy/MM/dd';
  showNoteflag: boolean;
  showchart: boolean;
  id_chart: string = 'link_Request';
  ComplianceIndexCondition: any;
  chartY: [];
  nzTitle: any;
  contractdata: any[] = [];
  listofreportdata: any;
  isVendor: boolean = false
  NTBCost: any;
  tw: boolean;
  cn: boolean;
  en: boolean;
  id: any;
  myChart;
  filename: any
  selectedValue: string = "";
  cancelSelection = false;
  UploadProofFile: NzUploadFile = null;
  date = null;
  isEnglish = false;
  isVisible = false;
  vendorData: any;
  checked = false;
  checkedVendor = false;
  indeterminate = false;
  indeterminateVendor = false;
  listOfCurrentPageData: readonly ItemData[] = [];
  listOfCurrentPageDataVendor: readonly ItemData[] = [];
  listOfData: any;
  setOfCheckedId = new Set<number>();
  setOfCheckedIdVendor = new Set<number>();
  maxId: number = 0;
  currentIndex: number = 0;

  constructor(
    private trlSev: TranslateService,
    private fb: FormBuilder,
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private matomotracker: MatomoTracker,
    private NzMessageService: NzMessageService,
    private http: HttpClient,
    private AuthService: AuthService,
    private LayoutComponent: LayoutComponent,
  ) { super(); }

  ngOnInit(): void {
    this.matomotracker.trackPageView("合同管理")
    this.matomotracker.trackEvent("合同管理", "合同发送", "Transation", 1);
    this.LayoutComponent.geturl()

    this.trlSev.onLangChange.subscribe(
      (event) => {
        this.trlSev.get('ContractInformation').subscribe((translation: string) => {
          this.ConcatTitle = translation;

        })
      })


    this.trlSev.onLangChange.subscribe(
      (event) => {
        this.trlSev.get('VendorInformation').subscribe((translation: string) => {
          this.VendorConcatTile = translation;
        })
      })

    this.GetSite()
    this.validateForm = this.fb.group({
      ContractName: [""],
      Versions: [''],
      ContractNameEn: [''],
      Type: [''],
      CNContractName: [''],
      ENContractName: [''],
      ModalVersions: [''],
      Site: [''],
      ModalType: [''],
      Background: ["", [Validators.maxLength(350)]],
      Purpose: ["", [Validators.maxLength(350)]],
      VendorCode1: [''],
      VendorName1: [''],
      ContactInformation: [''],
      datetime: ['']
    });

    this.GetLanguage();
  }

  GetSite() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteName.url}`;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.SiteList = res;
        this.validateForm.controls['Site'].setValue(this.SiteList[0].siteName);
      },
      (error) => {
      }
    );
  }

  //site排序
  compareSites(site1, site2) {
    let name1 = site1.siteName.toUpperCase();
    let name2 = site2.siteName.toUpperCase();
    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }
    return 0;
  }

  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }
  }

  getFormValue(value) {
    this.formValues = value;
  }

  getQuery(value) {
    this.isShowCondition = value;
  }

  onSearch() {
    this.isShowCondition = !this.isShowCondition;
    this.loading = true;
    this.GetLanguage();
    this.isShowinfo = true;
    this.loading = false;
  }

  showNote(note: string): void {
    if (note == 'isshowNote') {
      this.showNoteflag = true;
    }
  }

  CloseNote(note: string): void {
    this.showNoteflag = false;
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.total === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.total && this.pageIndex > 1) {
      this.pageIndex--;
    }
  }

  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;

  }


  public handleChange(info: NzUploadChangeParam): void {
    if (info.file.status === 'done') {
      this.uploadedFileName = info.file.response.name;
    }
  }




  onRadioClick(value: string): void {
    if (this.cancelSelection) {
      this.selectedValue = null;
      this.cancelSelection = false;
    } else {
      this.selectedValue = value;
    }
  }

  onCancelSelectionClick() {
    this.cancelSelection = true;
  }


  download(data) {
    this.webApiService.downloadFileByToken(data.fileToken).subscribe(
      (res) => {
        this.downloadFile8(res, data.fileName);

        this.trlSev.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   this.NzMessageService.success("下載成功");
        // }
        // if (language == 'zh-CN') {
        //   this.NzMessageService.success("下载成功");
        // }
        // if (language == 'en') {
        //   this.NzMessageService.success("download successfully");
        // }
      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  cancel(): void {
  }

  //删除合同信息
  confirm(data, i: number): void {

    this.contractdata[0].splice(i, 1)
    this.total = this.contractdata[0].length
  }



  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) <= 0;


  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {

    this.isVisible = false;
  }

  ADDContra() {
    this.isVisible = true;
  }

  //合同条件区后查询
  gettable1() {
    this.loading = true;

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetAdminContractList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Site: this.validateForm.controls['Site'].value,
        ChContractName: this.validateForm.controls['ContractName'].value,
        EnContractName: this.validateForm.controls['ContractNameEn'].value,
        Versions: this.validateForm.controls['Versions'].value,
        Status: "Y",
      }

    }
      ;
    this.webApiService.doPost(url, params).subscribe((res) => {
      if (this.contractdata.length === 0) {  // 如果第一次查询出来的数据要作为数组的第一个元素
        this.contractdata.push(res.data);
      } else {  // 如果不是第一次查询，就把数据插入到数组的尾部
        this.contractdata[0].splice(this.contractdata.length, 0, ...res.data);
      }

      this.total = this.contractdata[0].length
      this.trlSev.get('QuerySuccess').subscribe((translatedText: string) => {
        this.NzMessageService.success(translatedText);
      })
      //this.NzMessageService.success('查询成功');
      this.loading = false;
    });
    this.isVisible = false;
  }

  isVendorCancel() {
    this.isVendor = false
  }

  isVendorOk() {
    this.isVendor = false
    debugger
    if (this.PaddingData.length === 0) {  // 如果第一次查询出来的数据要作为数组的第一个元素
      this.vendorData.forEach(element => {
        element
      });
      this.PaddingData.push(this.vendorData);
    } else {  // 如果不是第一次查询，就把数据插入到数组的尾部
      this.PaddingData[0].splice(this.PaddingData.length, 0, ...this.vendorData);

    }

    this.PaddingData[0] = this.PaddingData[0].filter(
      (elem, index, self) =>
        index === self.findIndex(t => t.vendorMail === elem.vendorMail && t.supplierId === elem.supplierId && t.supplierName === elem.supplierName && t.phone === elem.phone && t.companyCode === elem.companyCode)
    );

    this.trlSev.get('AddVendorInformation').subscribe((translatedText: string) => {
      this.NzMessageService.success(translatedText);
    })

    // let language = sessionStorage.getItem("wmsmlang");
    // if (language == 'zh-TW') {
    //   this.NzMessageService.success('成功添加供應商信息，請勿上傳相同的信息');
    // }
    // if (language == 'zh-CN') {
    //   this.NzMessageService.success('成功添加供应商信息，请勿上传相同的信息');
    // }
    // if (language == 'en') {
    //   this.NzMessageService.success('Add supplier information successfully, do not upload the same information');
    // }
    //this.PaddingData = this.vendorData
  }

  isVendorOpen() {
    this.isVendor = true
    this.validateForm.reset();
    this.listOfData = []
    this.setOfCheckedId.clear()

  }


  //删除厂商信息
  deletevendor(data, i: number): void {

    this.PaddingData[0].splice(i, 1)
    //this.setOfCheckedId[0].delete(data.id);

  }

  //厂商信息勾选
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);

    } else {
      this.setOfCheckedId.delete(id);
    }
    var data = []

    this.setOfCheckedId.forEach(x => {
      var dto = this.listOfData.find(o => o.id == x);
      data.push(dto);
    })
    this.vendorData = data;
  }






  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));

    this.refreshCheckedStatus();

  }

  onCurrentPageDataChange($event: readonly ItemData[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }


  //Search Vendor
  Search() {

    if (this.validateForm.controls['VendorCode1'].value == "" || this.validateForm.controls['VendorCode1'].value == null) {

      this.trlSev.get('FirstEnterVendorInformation').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      // return  this.NzMessageService.warning('必須先輸入廠商信息');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('必须先输入厂商信息');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Vendor information must be entered first');
      // }
    }
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.AddVendorSearch.url}?vendorCode=` + this.validateForm.controls['VendorCode1'].value;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {

        if (res.length != 0) {
          this.setOfCheckedId.clear();
          this.listOfData = res.map((item, index) => ({
            id: this.currentIndex++,
            vendorContact: item.vendorContact,
            phone: item.phone,
            supplierName: item.supplierName,
            vendorMail: item.vendorMail,
            supplierId: item.supplierId,
            companyCode: item.companyCode,
            status: "N"
          }));

          this.validateForm.controls['VendorName1'].setValue(res[0].supplierName),
            this.validateForm.controls['VendorName1'].disable();

          this.trlSev.get('QuerySuccess').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          // let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //   this.NzMessageService.success('查詢成功');
          // }
          // if (language == 'zh-CN') {
          //   this.NzMessageService.success('查询成功');
          // }
          // if (language == 'en') {
          //   this.NzMessageService.success('Query success');
          // }

        } else {

          this.trlSev.get('VendorNoContact').subscribe((translatedText: string) => {
            this.NzMessageService.error(translatedText);
          })
          // let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //   this.NzMessageService.error('該廠商沒有聯繫人');
          // }
          // if (language == 'zh-CN') {
          //   this.NzMessageService.error('该厂商没有联系人');
          // }
          // if (language == 'en') {
          //   this.NzMessageService.error('The vendor has no contact');
          // }
        }

      },
      (error) => {
      }
    );
  }

  //下载模板
  DownloadTemplateExcel() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadTemplateExcel.url}`;
    const param = {};

    this.webApiService.doPost(url, param, true).subscribe((res) => {
      this.downloadFile8(res, `Contract_Vendor_Template_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }


  //批量上传
  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };

  beforeUpload111 = (file: NzUploadFile): boolean => {
    this.saveExcelData111(file);
    return false;
  };

  saveExcelData111(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    // 确定上传是否需要传递 EInvoice 参数
    formData.append('EInvoice', '...');
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UploadExcel111.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    (this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse)) as Observable<HttpResponse<any>>)
      .subscribe(
        (res) => {

        }
      );
    this.loading = false;
  }

  //批量上传
  saveExcelData(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    // 确定上传是否需要传递 EInvoice 参数
    formData.append('EInvoice', '...');
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ContractUploadExcel.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    (this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse)) as Observable<HttpResponse<any>>)
      .subscribe(
        (res) => {
          if (res.body.status == 200) {
            var data = []


            data = res.body.data.map((item, index) => ({
              id: this.currentIndex++,
              vendorContact: item.contact,
              phone: item.phone,
              supplierName: item.vendorName,
              vendorMail: item.email,
              supplierId: item.vendorCode,
              companyCode: item.companyCode,
              status: "N"
            }));


            if (this.PaddingData.length === 0) {  // 如果第一次查询出来的数据要作为数组的第一个元素
              this.PaddingData.push(data);
            } else {  // 如果不是第一次查询，就把数据插入到数组的尾部
              this.PaddingData[0].splice(this.PaddingData.length, 0, ...data);
            }

            this.PaddingData[0] = this.PaddingData[0].filter(
              (elem, index, self) =>
                index === self.findIndex(t => t.vendorMail === elem.vendorMail && t.supplierId === elem.supplierId && t.supplierName === elem.supplierName && t.phone === elem.phone && t.companyCode === elem.companyCode)
            );

            this.loading = false;
            // 提示上传成功信息
            if (res.body.msg) {
              let language = sessionStorage.getItem("wmsmlang");
              if (language == 'zh-TW') {
                this.NzMessageService.warning(res.body.msg);
              }
              if (language == 'zh-CN') {
                this.NzMessageService.warning(res.body.msg);
              }
              if (language == 'en') {
                this.NzMessageService.warning(res.body.msg);
              }
            }
            else {
              this.trlSev.get('AddVendorInformation').subscribe((translatedText: string) => {
                this.NzMessageService.success(translatedText);
              })
            }

            //   let language = sessionStorage.getItem("wmsmlang");
            // if (language == 'zh-TW') {
            // this.NzMessageService.success('成功添加供應商信息，請勿上傳相同的信息');
            // }
            // if (language == 'zh-CN') {
            // this.NzMessageService.success('成功添加供应商信息，请勿上传相同的信息');
            // }
            // if (language == 'en') {
            // this.NzMessageService.success('Add supplier information successfully, do not upload the same information');
            // }
          } else if (res.body.status == 0o0) {
            let language = sessionStorage.getItem("wmsmlang");
            if (language == 'zh-TW') {
              this.NzMessageService.warning(res.body.msg);
            }
            if (language == 'zh-CN') {
              this.NzMessageService.warning(res.body.msg);
            }
            if (language == 'en') {
              this.NzMessageService.warning(res.body.msg);
            }
            this.loading = false;
          }

        },
        (error) => {
          this.loading = false;
          // 处理上传失败错误信息
          if (error.status === 500) {
            this.trlSev.get('ServerError').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            // this.NzMessageService.error('服务器错误，请稍后再试！');
          } else if (error.status === 400) {
            this.trlSev.get('UploadFailed2').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            //this.NzMessageService.error('上传失败，请检查是否上传了正确格式的文件！');
          } else {
            this.trlSev.get('UploadFailed').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            //this.NzMessageService.error('上传失败，请稍后再试！');
          }
        }
      );
  }


  //送出
  SendOut() {

    if (this.PaddingData[0] == undefined) {
      this.trlSev.get('PleaseSelectVendor').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('請選擇供應商');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('请选择供应商');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Please select a vendor');
      // }
    }
    if (this.contractdata[0] == undefined) {
      this.trlSev.get('SelectContractTemplate').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('請選擇合同模板');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('请选择合同模板');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Please select a contract template');
      // }
    }

    var dataVendor = []
    dataVendor = this.PaddingData[0].map((item) => ({
      Contact: item.vendorContact,
      Phone: item.phone,
      VendorName: item.supplierName,
      Email: item.vendorMail,
      VendorCode: item.supplierId,
      status: item.status
    }));

    var dataContract = []
    dataContract = this.contractdata[0].map((item) => ({
      Site: item.site,
      ContractName: item.chContractName,
      Version: item.versions,
      Status: item.status,
      EnContractName: item.enContractName,
      BackGroud: item.backGround,
      Goal: item.goal,
      Filetoken: item.fileToken,
      approvalTimeLimit: item.approvalTimeLimit,
      TypeCode: item.typeCode
    }));
    if (dataContract.length == 0) {
      this.trlSev.get('PleaseSelectVendor').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
    }
    if (dataVendor.length == 0) {
      this.trlSev.get('SelectContractTemplate').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
    }
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.SendContract.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        contractList: dataContract,
        vendorList: dataVendor,
      }
    };

    this.webApiService.doPost(url, params).subscribe((res) => {

      this.trlSev.get('SentSuccessfully').subscribe((translatedText: string) => {
        this.NzMessageService.success(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   this.NzMessageService.success('成功發送！');
      // }
      // if (language == 'zh-CN') {
      //   this.NzMessageService.success('成功发送！');
      // }
      // if (language == 'en') {
      //   this.NzMessageService.success('sent successfully');
      // }
      this.contractdata = [];
      this.PaddingData = [];


      this.loading = false;
    });
  }

  CheckedSetVendor(id: number, checkedVendor: boolean): void {

    if (checkedVendor) {

      this.setOfCheckedIdVendor.add(id);
      const idToUpdate = this.PaddingData[0].findIndex(item => item.id === id);
      this.PaddingData[0][idToUpdate].status = 'Y';
      var dto = this.PaddingData[0];
      this.PaddingData[0].find(o => o.id == id);
    } else {
      this.setOfCheckedIdVendor.delete(id);
      const idToUpdate = this.PaddingData[0].findIndex(item => item.id === id);
      if (idToUpdate !== -1) {
        this.PaddingData[0][idToUpdate].status = "N"; // 设置为 null 或者其他特定的值
      }

    }
  }

  onItemCheckedVendor(id: number, checkedVendor: boolean): void {
    this.CheckedSetVendor(id, checkedVendor);
    this.refreshCheckedStatusVendor();
  }

  onAllCheckedVendor(value: boolean): void {

    this.listOfCurrentPageDataVendor.forEach(item => this.CheckedSetVendor(item.id, value));

    this.refreshCheckedStatusVendor();

  }

  onCurrentPageDataChangeVendor($event: readonly ItemData[]): void {
    this.listOfCurrentPageDataVendor = $event;
    this.refreshCheckedStatusVendor();
  }

  refreshCheckedStatusVendor(): void {
    this.checkedVendor = this.listOfCurrentPageDataVendor.every(item => this.setOfCheckedIdVendor.has(item.id));
    this.indeterminateVendor = this.listOfCurrentPageDataVendor.some(item => this.setOfCheckedIdVendor.has(item.id)) && !this.checkedVendor;
  }


}


